import { Mui } from '@osu/react-ui';
import ExternalLink from '../../../Common/components/ExternalLink';

/**
 * StepField Component for V2
 * Displays individual field information within a step
 */
function StepField({ field }) {
  if (!field) {
    return null;
  }

  const { label, value, type = 'text' } = field;

  const renderFieldValue = () => {
    switch (type) {
      case 'date':
        if (!value) return 'Not available';
        try {
          return new Date(value).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
        } catch {
          return value;
        }

      case 'status':
        return (
          <Mui.Chip
            label={value || 'Unknown'}
            color={getStatusColor(value)}
            variant="outlined"
            size="small"
          />
        );

      case 'link':
        return (
          <ExternalLink
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
          >
            {value}
          </ExternalLink>
        );

      case 'email':
        return (
          <ExternalLink
            href={`mailto:${value}`}
            color="primary"
          >
            {value}
          </ExternalLink>
        );

      case 'phone':
        return (
          <ExternalLink
            href={`tel:${value?.replace(/[^0-9]/g, '')}`}
            color="primary"
          >
            {value}
          </ExternalLink>
        );

      default:
        return value || 'Not available';
    }
  };

  const getStatusColor = (status) => {
    if (!status) return 'default';
    const statusLower = status.toLowerCase();
    
    if (statusLower.includes('complete') || statusLower.includes('accepted')) {
      return 'success';
    }
    if (statusLower.includes('progress') || statusLower.includes('review')) {
      return 'primary';
    }
    if (statusLower.includes('pending') || statusLower.includes('waiting')) {
      return 'warning';
    }
    if (statusLower.includes('denied') || statusLower.includes('error')) {
      return 'error';
    }
    return 'default';
  };

  return (
    <Mui.Box sx={{ mb: 2 }}>
      <Mui.Typography 
        variant="subtitle2" 
        color="text.secondary" 
        sx={{ mb: 0.5 }}
      >
        {label}
      </Mui.Typography>
      <Mui.Typography variant="body1">
        {renderFieldValue()}
      </Mui.Typography>
    </Mui.Box>
  );
}

export default StepField;